import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryBulkyProduction = () => {
  return <CategoryBase baseEndpoint="category_bulky_production" />;
};

export default CategoryBulkyProduction;
